import { isCustomizationFeatureEnabled } from '../../handoff-metrics/handoff-metrics-helpers';
import { onlineSchedulingHealthMetric } from '../../handoff-metrics/metrics/online-scheduling';
import { UnifyMetricDefinition } from '../unify-metrics.types';
import { adaptHandoffMetric } from './adapt-handoff-metric';

export const onlineScheduleHealthMetricDef: UnifyMetricDefinition = {
  id: 'online_schedule_health',
  name: 'Online Schedule Health',
  sectionName: 'Online Schedule',
  allowExceptions: true,
  shouldSkip: (ctx) => !isCustomizationFeatureEnabled('Online Scheduling', ctx.features),
  criteria: [adaptHandoffMetric(onlineSchedulingHealthMetric)],
};
